// extracted by mini-css-extract-plugin
export default {"root":"RegistrationsDisabled_root__yVZHY","explain":"RegistrationsDisabled_explain__5yYv9"};